import React, { PropsWithChildren, HTMLAttributes } from "react";
import { makeStyles } from '@mui/styles';
import { hexToComponents } from "../../utils/helpers";

type ToolsColorSwatchProps = HTMLAttributes<HTMLElement> & PropsWithChildren<{
	color: string,
	isSelected: boolean
}>

const useStyles = makeStyles(theme => ({
	container: {
		width: 20,
		height: 20,
		border: "solid 1px",
		borderRadius: "50%",
		cursor: "pointer",
		position: "relative",
		boxSizing: "border-box",
		"&.transparent": {
			backgroundSize: "10px 10px",
			backgroundPosition: "0 0, 5px 5px",
			backgroundImage: `linear-gradient(45deg, #d1d1d1 25%, transparent 25%, transparent 75%, #d1d1d1 75%, #d1d1d1),
			                  linear-gradient(45deg, #d1d1d1 25%, transparent 25%, transparent 75%, #d1d1d1 75%, #d1d1d1)`
		},
		"&.selected::before": {
			content: "''",
			width: 24,
			height: 24,
			position: "absolute",
			left: -4,
			top: -4,
			border: "1px solid #566271",
			borderRadius: "50%",
			pointerEvents: "none"
		}
	}
}));

const ToolsColorSwatch = ({ color = 'transparent', isSelected = false, ...props }: ToolsColorSwatchProps) => {
	const classes = useStyles();

	const handleClick = e => {
		props.onClick(e);
	};

	function contrastColor(val) {
		if (val === "transparent") return "#d1d1d1";
		const { h, s, l } = hexToComponents(val);
		return `hsl(${h}, ${s - 20}%, ${l - 10}%)`;
	}

	return (
		<div
			className={`cb-color-swatch ${classes.container} ${isSelected ? "selected" : ""
				} ${color === "transparent" ? "transparent" : ""}`}
			style={{
				backgroundColor: color,
				borderColor: contrastColor(color)
			}}
			{...props}
			onClick={handleClick}>
		</div>
	);
}

export default ToolsColorSwatch;
